"use client"

import SearchScreen from "./search-input-small-screen/SearchInputMobile";
import { Toggle } from "src/components/ui/toggle";
import getUserId from "src/utils/getUserId";
import { Bell, Heart, Mail, Search } from "lucide-react";
import Link from 'next/link';

const NavButtons = ({ isMobileScreen }: { isMobileScreen?: boolean }) => {
    const userId = getUserId();

    return (
        <div className="my-auto flex h-full items-center justify-center gap-x-0 text-quaternary dark:text-white">
            {isMobileScreen && (<SearchScreen
                press={
                    <Toggle size="sm" aria-label="Search" className="2 ">
                        <Search size="25" />
                    </Toggle>
                }
            />
            )}
            {userId && (
                <>
                    <Toggle
                        size="sm"
                        aria-label="Chat"
                    >
                        <Link href="/chat"> <Mail size={22} className="h-full" /> </Link>
                    </Toggle>
                    <Toggle size="sm" aria-label="Notifications">
                        <Bell size={22} />
                    </Toggle>
                    <Toggle
                        size="sm"
                        aria-label="Favorite item"
                    >
                        <Link href={`/favorite-items?userId=${userId}`}> <Heart size={22} />
                        </Link>
                    </Toggle>
                </>
            )}
        </div>
    )
}

export default NavButtons
